module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media",
    class: _vm.type
  }, [_c('div', {
    staticClass: "media__image",
    style: (("background-image: url(" + _vm.image + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', [_c('div', {
    staticClass: "media__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "media__description"
  }, [_vm._v(_vm._s(_vm.subtitle))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20cbace0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/video/components/attach_card.vue
// module id = 1648
// module chunks = 180